import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { GuestGuard } from "src/auth/guard";
import AuthClassicLayout from "src/layouts/auth/classic";
import { SplashScreen } from "src/components/loading-screen";

// ----------------------------------------------------------------------

// JWT
const JwtForgotPasswordView = lazy(
  () => import("src/pages/auth/jwt/forgot-password")
);
const JwtVerifyView = lazy(() => import("src/pages/auth/jwt/verify"));
const JwtNewPasswordView = lazy(
  () => import("src/pages/auth/jwt/new-password")
);

// ----------------------------------------------------------------------

const authJwt = {
  path: "jwt",
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: "forgot-password",
      element: (
        <AuthClassicLayout title="forgot_password_title">
          <JwtForgotPasswordView />
        </AuthClassicLayout>
      ),
    },
    {
      path: "new-password",
      element: (
        <AuthClassicLayout title="set_your_new_password">
          <JwtNewPasswordView />
        </AuthClassicLayout>
      ),
    },
    {
      path: "verify",
      element: (
        <AuthClassicLayout title="email_verification">
          <JwtVerifyView />
        </AuthClassicLayout>
      ),
    },
  ],
};

export const authRoutes = [
  {
    path: "auth",
    children: [authJwt],
  },
];
